module.exports = __webpack_public_path__ + "static/media/visitorsactive.eafb1a40.svg";